import React from 'react';
import MailRed from '../../../../../assets/icons/inline/mail-yellow.inline.svg';
import MailBlue from '../../../../../assets/icons/inline/mail-blue.inline.svg';
import Phone from '../../../../../assets/icons/inline/phone-red.inline.svg';
import * as classes from './Contacts.module.scss';
import cn from 'classnames';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import Link from '../../../../Common/Link/Link';

interface Props {
  phone: string;
  email: string;
}

const Contacts = ({ phone, email }: Props) => {
  const { t } = useTranslation();
  return (
    <div className={classes.wrapper}>
      <div className={cn(classes.item, classes.red)}>
        <div className={cn(classes.icon, classes.red)}>
          <Phone />
        </div>
        <div>
          <a href={`tel:${phone}`}>{phone}</a>
        </div>
      </div>

      <div className={cn(classes.item, classes.yellow)}>
        <div className={cn(classes.icon, classes.yellow)}>
          <MailRed />
        </div>
        <div>
          <a href={`mailto:${email}`}>{t('homePage.infoSection.sendEmail')}</a>
        </div>
      </div>

      <div className={cn(classes.item, classes.blue)}>
        <div className={cn(classes.icon, classes.blue)}>
          <MailBlue />
        </div>
        <div>
          <Link path={t('homePage.infoSection.workScheduleUrl')} title={'homePage.infoSection.workScheduleTitle'}>
            {t('homePage.infoSection.workSchedule')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Contacts;
